module.exports = __webpack_public_path__ + "static/media/FONDO-REGISTRO-INICIAL.0d02e0b8.png";